export const displayLastFourDigitsSsn = ssn => {
    if (ssn == null) {
        return false;
    }
    return "xxx-xx-" + (ssn.replace(/-/g, "") % 10000);
};
